"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// All filter words to filter in the ESN project
var Filter = {
  view_results: {
    nl: 'Resultaten overzicht',
    fr: 'Vue résultats',
    en: 'Results view'
  },
  view_map: {
    nl: 'Kaart overzicht',
    fr: 'Vue carte',
    en: 'Map view'
  },
  view_on_results: {
    nl: 'Wijzig resultaten naar galerijoverzicht',
    fr: 'Modifier résultats vers galerie',
    en: 'Change results to gallery view'
  },
  view_on_map: {
    nl: 'Wijzig resultaten naar kaartoverzicht',
    fr: 'Modifier résultats vers maps',
    en: 'Change results to map view'
  },
  title_order: {
    nl: 'Sorteren op',
    fr: 'Ordre par',
    en: 'Order by'
  },
  title_open: {
    nl: 'Open op',
    fr: 'Ouvert le',
    en: 'Open at'
  },
  title_category: {
    nl: 'Toon categorie',
    fr: 'Par catégorie',
    en: 'Show category'
  },
  btocb: {
    nl: 'Beide',
    fr: 'Les deux',
    en: 'Both'
  },
  filter: {
    nl: 'Filter',
    fr: 'Filtre',
    en: 'Filter'
  },
  sort: {
    nl: 'Sorteren',
    fr: 'Trier',
    en: 'Sort'
  },
  sort_coming_soon: {
    nl: 'Sorteren Binnnenkort mogelijk',
    fr: 'Trier bientôt possible',
    en: 'Sorting results coming soon'
  },
  recent_date: {
    nl: 'Recentste datum',
    fr: 'date la plus récente',
    en: 'Most recent date'
  },
  oldest_date: {
    nl: 'Oudste datum',
    fr: 'Date la plus ancienne',
    en: 'Oldest date'
  },
  alphabetical: {
    nl: 'A - Z',
    fr: 'A - Z',
    en: 'A - Z'
  },
  unalphabetical: {
    nl: 'Z - A',
    fr: 'Z - A',
    en: 'Z - A'
  }
};
var _default = Filter;
exports["default"] = _default;